import { useLocation, Navigate, Outlet } from "react-router-dom";
import UseAuth from "../../hooks/UseAuth";

// helpers
const isAuthed = (auth) =>
  Boolean(auth && auth.accessToken && auth.accessToken !== "");

const RequireAuth = () => {
  const { auth } = UseAuth();
  const location = useLocation();

  // Must be logged in. Disabled users pass here.
  if (!isAuthed(auth)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
